module.exports = __webpack_public_path__ + "static/media/yelpcamp3.4bd92745.jpg";